import get from 'lodash.get';
import { SprayEventApplicationType } from 'services/sprayEvents/types';
import {
    FertilizerWorksheetEntitySummary,
    WorksheetEntitySummary,
    WorksheetEntitySummaryInnerEntity,
    WorksheetPageIndex
} from './types';

export function getWorksheetInnerEntitiesAsString(
    entitySummaries: WorksheetEntitySummary[],
    worksheetPageIndex: WorksheetPageIndex
): string {
    const innerEntities = get(entitySummaries, [
        worksheetPageIndex,
        'innerEntities'
    ]);

    return innerEntities
        .map(({ name }: WorksheetEntitySummaryInnerEntity) => {
            return name;
        })
        .join(', ');
}

export function getWorksheetInnerEntities(
    entitySummaries: WorksheetEntitySummary[],
    worksheetPageIndex: WorksheetPageIndex
): string {
    const varietyName = get(entitySummaries, [
        worksheetPageIndex,
        'variety',
        'name'
    ]);
    const isSprayingAll = get(entitySummaries, [
        worksheetPageIndex,
        'isSprayingAll'
    ]);
    const isSprayingVariety = get(entitySummaries, [
        worksheetPageIndex,
        'isSprayingVariety'
    ]);

    if (isSprayingAll) {
        return 'All blocks';
    }

    if (isSprayingVariety) {
        return `All ${varietyName}`;
    }

    return getWorksheetInnerEntitiesAsString(
        entitySummaries,
        worksheetPageIndex
    );
}

export function getWorksheetHeaderEntities(
    entitySummaries: FertilizerWorksheetEntitySummary[]
): string {
    const entityNames = entitySummaries.reduce(
        (acc: string[], cur: FertilizerWorksheetEntitySummary) => {
            const entityName = get(cur, ['entity', 'name']);

            if (entityName && !acc.includes(entityName)) {
                acc.push(entityName);
            }

            return acc;
        },
        []
    );

    return entityNames.join(', ');
}
